import { OneColumn } from 'components/page';
import { PreenchimentoGrid, PreenchimentoListFilter, PreenchimentoPainelExportacao } from 'pages/financeiro/dre/preenchimento/components';

export function PreenchimentoListComp() {
    return (
        <OneColumn title="Preenchimento de Estimativa de Resultado" goBackButton>
            <PreenchimentoListFilter />

            <PreenchimentoPainelExportacao />

            <PreenchimentoGrid />
        </OneColumn>
    );
}
